import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { HaclMapperMsgConversionApiRef } from './api/HaclMapperMsgConversionApi';
import { HaclMapperMsgConversionClient } from './api/HaclMapperMsgConversionClient';
import { rootRouteRef } from './routes';

export const HaclMapperMsgConversionPlugin = createPlugin({
  id: 'hacl-mapper-message-conversion',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: HaclMapperMsgConversionApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new HaclMapperMsgConversionClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const HaclMapperMsgConversionPage =
  HaclMapperMsgConversionPlugin.provide(
    createRoutableExtension({
      name: 'HaclMapperMessageConversion',
      component: () => import('./components/MainPage').then(m => m.MainPage),
      mountPoint: rootRouteRef,
    }),
  );
